import { CSSProperties } from 'react';
import { Container } from '@/components/Container';
import { Placeholder } from '@/components/atoms/placeholder';
import ProductPlaceholder from '@/components/Product/ProductPlaceholder';
import { GetStoreMetadata } from 'data/Utils';
import { SPACING_VALUES } from '@/utils';

const RelatedProductPlaceholder = async () => {
  const data = await GetStoreMetadata();
  const productCard = data?.productCard;
  const { isLargeCard, spacingBetweenCard } = productCard.displayProps;

  const selectedSpacing =
    SPACING_VALUES[spacingBetweenCard] || SPACING_VALUES.small;

  return (
    <section className="placeholder__products_related">
      <div className="placeholder__related_header">
        <Placeholder className="placeholder__related_title" />
        <Placeholder className="placeholder__related_actions" />
      </div>
      <Container
        className={'placeholder__related_container'}
        style={
          {
            '--gap-default': `${selectedSpacing.default}px`,
            '--gap-sm': `${selectedSpacing.sm}px`,
            '--gap-md': `${selectedSpacing.md}px`,
            '--gap-xl': `${selectedSpacing.xl}px`,
            '--gap-xxl': `${selectedSpacing.xxl}px`,
          } as CSSProperties
        }
      >
        {Array.from({ length: 20 }).map((_, index) => (
          <ProductPlaceholder key={index} largeCard={isLargeCard} />
        ))}
      </Container>
    </section>
  );
};

export { RelatedProductPlaceholder };
